import * as d3 from 'd3';
import { ElementRender } from './ElementeRenderer';
import { LineDefinition, renderLines } from './renderLines';

export class HorizontalLines extends ElementRender {
    private _classes: string;
    constructor(selection: d3.Selection<any>, classed: string) {
        super(selection, classed);
    }

    classes(): string;
    classes(value: string): this;
    classes(value?: string) {
        if (!arguments.length) {
            return this._classes;
        }
        this._classes = value;
        return this;
    }

    render(ticks: { y: number, color?: string }[]) {
        const lines: LineDefinition[] = ticks.map(t => {
            return {
                x1: 0, x2: this.width(), y1: t.y, y2: t.y, color: t.color
            };
        });
        renderLines(lines, this.container(), this.visible(), this._classes);
    }
}